import _Vue from "vue";
import {DEFAULT_NUMBER_DECIMAL} from "../../common/constants";

export class PluginOptions { }

const DecimalFormatByLocale = {
	install(Vue: typeof _Vue, options?: PluginOptions) {
		Vue.prototype.$decimalFormat = function(value): number {
			if (!value || typeof value !== 'number') return value;
			let decimalSeparate = this.$formatPattern()[2];
			let newValue = value.toFixed(4).replace(new RegExp(`[0]+$`), "");
			switch (decimalSeparate) {
				case ".":
					return parseFloat(newValue.replace("[\.]$", ""));
				case ",":
					return parseFloat(newValue.replace("[\,]$", ""));
				default:
					return parseFloat(newValue);
					
			}
		};
		
		Vue.prototype.$formatPattern = function () {
			const pattern = Intl.NumberFormat(this.$i18n.locale).format(-1234.56);
			const results: string[] = [];
			for (let i = 0; i < pattern.length; i++) {
				if (!parseInt(pattern[i])) {
					results.push(pattern[i])
				}
			}
			return results
		};
		
		Vue.prototype.$formatNumberByLocale = function (value: number) {
			if (typeof value !== 'number') return value;
			return Intl.NumberFormat(this.$i18n.locale, {
				maximumFractionDigits: DEFAULT_NUMBER_DECIMAL.maximumFractionDigits
			}).format(value);
		}
	}
};

export default DecimalFormatByLocale;

declare module 'vue/types/vue' {
	interface Vue {
		$decimalFormat: (value?: number) => number;
		$formatPattern: () => void;
		$formatNumberByLocale: (value: number) => number;
	}
}